import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import Modal from 'components/modal/Modal'

import styles from './tooltip.scss'

interface IProps {
  className?: string
  target: React.RefObject<any>
  targetOffsetX?: number
  targetOffsetY?: number
  darken?: boolean
  children: React.ReactChild
  onClickOutside?: () => void
}

const Tooltip = ({
  className,
  target,
  targetOffsetX,
  targetOffsetY,
  darken,
  children,
  onClickOutside,
}: IProps) => {
  return (
    <Modal
      className={cn(styles.container, className)}
      target={target}
      targetOffsetX={targetOffsetX}
      targetOffsetY={targetOffsetY}
      darken={darken}
      onClickOutside={onClickOutside}
    >
      {children}
    </Modal>
  )
}

export default observer(Tooltip)
